import React, { useEffect, useState } from 'react';
import 'leaflet/dist/leaflet.css';
import './PopupNCU.css';
import { useTranslation } from 'react-i18next';

const PopupNCU = (props) => {

    const { t } = useTranslation();
    const { idNCU, tcu, tcuOk, tcuWarning, tcuBad, tcuNoComm } = props;
    var link = "/#/ncu/" + idNCU;

    //Deshabilitar el link si no hay pantalla de NCU
    const screen = JSON.parse(sessionStorage.getItem('ScreenConfiguration')).filter(screen => screen.Screen === "NCU");
    const [hrefDisabled, setHrefDisabled] = useState(<></>);

    useEffect(() => {
        if (screen[0].Enabled === false) {
            setHrefDisabled(<a className='a-ver-tcu' style={{ cursor: 'none' }}>NCU {idNCU}</a>)
        } else {
            setHrefDisabled(<a className='a-ver-tcu' href={link}>NCU {idNCU}</a>)
        }
    }, []);


    return (
        <div className='container-fluid' style={{ width: 'max-content', padding: '0px' }}>
            <div className='row justify-content-center mb-3'>
                <div className='col-auto'>
                    {hrefDisabled}
                </div>
            </div>
            <div className='row' style={{ margin: '5px' }}>
                <div className='col-auto'>{t('scada.map.popupNCU.numberTCU')} <strong>{tcu}</strong></div>
                <div className='col-auto'>{t('scada.map.popupNCU.warning')} <strong>{tcuWarning}</strong></div>
            </div>
            <div className='row' style={{ margin: '5px' }}>
                <div className='col-auto'>{t('scada.map.popupNCU.ok')} <strong>{tcuOk}</strong></div>
                <div className='col-auto'>{t('scada.map.popupNCU.fail')} <strong>{tcuBad}</strong></div>
            </div>
            <div className='row' style={{ margin: '5px' }}>
                <div className='col-auto'>{t('scada.map.popupNCU.failCom')} <strong>{tcuNoComm}</strong></div>
            </div>
        </div>
    );
};

export default PopupNCU;